import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Container, Input, Row, Spinner } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import CommonTable from "../../Components/Common/Table/CommonTable";
import { fetchAllCountry, fetchCountryTableColumnNames, toggleCountryStatus, updateCountry } from "../../slices/country/thunk";
import { toast } from "react-toastify";
import CommonDataTable from "../../Components/Common/Table/CommonDataTable";
import usePermissions from "../../Components/Hooks/usePermissions";

function CountryMasterTable() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {user} = getAuthUser();
  const [searchTerm, setSearchTerm] = useState("");  


  const { country, loading, error, tableColumnNames, module } = useSelector((state) => ({
    country: state.Country.country,  
    loading: state.Country.loading,
    error: state.Country.error,
    tableColumnNames: state.Country.tableColumnNames,
    module: state.Module.module, 
  }));

  // Compute permission
  const permission = (() => {
    return usePermissions(3, 10);
  })();

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchCountryTableColumnNames({ module: "COUNTRY"})).unwrap();
        await dispatch(fetchAllCountry());
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [dispatch, user.UserId]);

  const handleToggleCountryStatus = (countryRow) => {
    if (!permission.CanToggle) { 
      toast.error(t("NoPermissionToEdit"));
      return;
    }
    const countryData = {
      ID: countryRow.ID, 
      IsActive: !countryRow.IsActive,
    };
    dispatch(toggleCountryStatus(countryData));
  };

  const handleInlineUpdate = async (item, columnKey, newValue) => {
    if (!permission.CanEdit) {
      toast.error(t("NoPermissionToEdit"));
      return;
    }
    const payload = {
      ID: item.ID,
      [columnKey]: newValue,
    };
    try {
      await dispatch(updateCountry(payload)).unwrap();
      toast.success(t("CountryUpdatedSuccessfully"));
     
    } catch (error) {
      toast.error(t("ErrorUpdatingCountry") + (error.message ? `: ${error.message}` : ''));
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t("Country")} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            <CardHeader>
                <Row className="g-4">
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
                </Row>
            </CardHeader>

            <CardBody>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center">
                 <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                  Loading...
                 </Spinner>
                </div>
              ) : (
                <div className="listjs-table" id="customerList">
                  {/* <CommonTable
                    data={country}
                    tableColumnNames={tableColumnNames}
                    searchTerm={searchTerm}
                    hasAction={false} 
                    onInlineUpdate={handleInlineUpdate}
                    onActiveOrDeactiveChange={handleToggleCountryStatus} 
                    permission={permission} 
                  /> */}
                  <CommonDataTable
                    data={country}
                    tableColumnNames={tableColumnNames}
                    searchTerm={searchTerm}
                    onActiveOrDeactiveChange={handleToggleCountryStatus}
                    onInlineUpdate={handleInlineUpdate}
                    permission={permission}
                    />
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </Container>
    </div>
  );
}

export default CountryMasterTable;
